'use client';
import * as React from 'react';
import { useARIAButtonProps } from '@fluentui/react-aria';
import { getIntrinsicElementProps, slot } from '@fluentui/react-utilities';
/**
 * Given user props, defines default props for the Button, calls useButtonState, and returns processed state.
 * @param props - User provided props to the Button component.
 * @param ref - User provided ref to be passed to the Button component.
 */ export const useButtonBase_unstable = (props, ref)=>{
    const { as = 'button', disabled = false, disabledFocusable = false, icon, iconPosition = 'before' } = props;
    const iconShorthand = slot.optional(icon, {
        elementType: 'span'
    });
    return {
        // Props passed at the top-level
        disabled,
        disabledFocusable,
        iconPosition,
        iconOnly: Boolean((iconShorthand === null || iconShorthand === void 0 ? void 0 : iconShorthand.children) && !props.children),
        // Slots definition
        components: {
            root: 'button',
            icon: 'span'
        },
        root: slot.always(getIntrinsicElementProps(as, useARIAButtonProps(props.as, props)), {
            elementType: 'button',
            defaultProps: {
                ref: ref,
                type: as === 'button' ? 'button' : undefined
            }
        }),
        icon: iconShorthand
    };
};
